import { App as AntDApp, ConfigProvider } from "antd";
import { RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store";
import router from "./routes/router";

const App = () => {
  return (
    <Provider store={store}>
      <ConfigProvider
        theme={{
          token: {
            fontFamily: "Noto Sans",
            // colorPrimary: "#D86800",
            // colorPrimary: "#CA325B",
            colorPrimary: "#276987",
            borderRadius: 4,
            colorSuccess: "#46B274",
          },
          components: {
            // Button: {
            //   algorithm: true,
            //   borderRadius: 4,
            // },
            Tabs: {
              inkBarColor: "#4D4D4D",
              itemSelectedColor: "rgba(0, 0, 0, 0.87)",
              itemHoverColor: "rgba(0, 0, 0)",
            },
          },
        }}
      >
        <AntDApp>
          <div className="default-text">
            <RouterProvider router={router} />
          </div>
        </AntDApp>
      </ConfigProvider>
    </Provider>
  );
};

export default App;
